import {
    Component,
    ContentChild,
    ElementRef,
    HostListener,
    Input,
    Output,
    ViewChild,
    ViewContainerRef,
    EventEmitter
} from '@angular/core';
import {DialogContentDirective} from './dialog-content.directive';
import {DialogFooterDirective} from './dialog-footer.directive';
import {DialogHeaderDirective} from './dialog-header.directive';

@Component({
    selector: '[appDialog]',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent {
    @ContentChild(DialogContentDirective) content: DialogContentDirective;
    @ContentChild(DialogHeaderDirective) header: DialogHeaderDirective;
    @ContentChild(DialogFooterDirective) footer: DialogFooterDirective;

    @ViewChild('contentVcr', { read: ViewContainerRef, static: true })
    private contentVcr: ViewContainerRef;

    @ViewChild('headerVcr', { read: ViewContainerRef, static: true })
    private headerVcr: ViewContainerRef;

    @ViewChild('footerVcr', { read: ViewContainerRef, static: true })
    private footerVcr: ViewContainerRef;

    @Input() title: string;

    @Output() onHide = new EventEmitter();

    constructor(private host: ElementRef) {}

    showModal() {
        this.host.nativeElement.showModal();
        this.contentVcr.createEmbeddedView(this.content.tpl);
        this.header?.tpl && this.headerVcr.createEmbeddedView(this.header.tpl);
        this.footer?.tpl && this.footerVcr.createEmbeddedView(this.footer.tpl);
    }

    close() {
        this.element.addEventListener(
            'animationend',
            (e: AnimationEvent) => {
                if (e.animationName.includes('fadeOut')) {
                    this.element.close();
                    this.clear();
                    this.element.removeAttribute('closing');
                    this.onHide.next(this.element);
                }
            },
            { once: true }
        );

        this.element.setAttribute('closing', 'true');
    }

    private get element() {
        return this.host.nativeElement;
    }

    private clear() {
        this.contentVcr.clear();
        this.footerVcr.clear();
        this.headerVcr.clear();
    }

    @HostListener('click', ['$event'])
    onDialogClick(event: MouseEvent) {
        if ((event.target as any).nodeName === 'DIALOG') {
            this.close();
        }
    }

    @HostListener('cancel')
    onDialogCancel() {
        this.clear();
    }
}

@Component({
  template: ''
})
export abstract class Dialog {
    @ViewChild('dialog')
    private dialog: DialogComponent;

    @Output() onClose = new EventEmitter();
    showModal() {
        this.dialog.showModal();
        this.dialog.onHide.subscribe((source: any) => {
            this.onClose.next(source);
        });
    }

    close() {
        this.dialog.close();
    }
}


